<button
  *ngIf="operationsFormArray.controls.length > 1"
  class="border-common operation-delete-button"
  mat-button
  type="button"
  [matTooltip]="'Remove Condition'"
  [hidden]="operationsFormArray.controls.length < 1"
  data-test="button-remove-operation"
  (click)="removeOperation()"
>
  <fa-icon class="text-gray-600" [icon]="['fal', 'trash-alt']"></fa-icon>
</button>
